<template>
	<section>
		<v-stepper v-model="step" alt-labels>
			<v-stepper-header>
				<v-stepper-step :step="stepType"
				                :complete-icon="icons.yes"
				                :edit-icon="stepTypeComplete ? icons.yes : icons.edit"
				                editable :complete="stepTypeComplete"
				                class="stepper-step">
					{{ $t('user.terms.account') }}
				</v-stepper-step>
				<v-stepper-step :step="stepUser"
				                :complete-icon="icons.yes"
				                :edit-icon="stepUserComplete ? icons.yes : icons.edit"
				                :editable="stepTypeComplete" :complete="stepUserComplete"
				                class="stepper-step">
					{{ $t('user.singular') }}
				</v-stepper-step>
				<v-stepper-step :step="stepAddresses"
				                :complete-icon="icons.yes"
				                :edit-icon="stepAddressesComplete ? icons.yes : icons.edit"
				                :editable="stepTypeComplete && stepUserComplete" :complete="stepAddressesComplete"
				                class="stepper-step">
					{{ $t('address.plural') }}
				</v-stepper-step>
				<v-stepper-step :step="stepSummary"
				                :complete-icon="icons.yes"
				                :edit-icon="icons.yes"
				                :editable="stepTypeComplete && stepUserComplete && stepAddressesComplete && summaryStepVisited"
				                :complete="stepTypeComplete && stepUserComplete && stepAddressesComplete && summaryStepVisited"
				                class="stepper-step">
					{{ $t('ui.terms.summary') }}
				</v-stepper-step>
			</v-stepper-header>
			<v-stepper-items>
				<v-stepper-content :step="stepType" class="pa-0 scrollable-content">
					<v-form ref="creationForm" v-model="typeDataValid">
						<div class="ma-6">
							<AsiRadioGroup v-model="model.type" :rules="model.rules('type')">
								<AsiCard unwrapped :title="$t('constants.business')">
									<template v-slot:title>
										<div class="d-flex flex-row align-center pointer" @click="model.type = typeBusiness">
											<div class="mr-3">
												<v-radio :value="typeBusiness" class="ma-3"/>
											</div>
											<div class="headline">
												{{ $t('constants.business') }}
											</div>
										</div>
									</template>
									<v-card-text class="pa-6">
										<AsiTextField v-model="model.customerName"
										              :label="$t('customer.name')"
										              :placeholder="$t('customer.name')"
										              :rules="model.type === typeBusiness ? model.rules('customerName') : []"
										              :disabled="model.type !== typeBusiness"/>
										<AsiTextField v-model="model.phone"
										              :label="$t('customer.phone')"
										              :placeholder="$t('customer.phone')"
										              :rules="model.type === typeBusiness ? model.rules('phone') : []"
										              :disabled="model.type !== typeBusiness"
										              class="mt-4"/>
									</v-card-text>
								</AsiCard>
								<AsiCard unwrapped no-bottom-margin>
									<template v-slot:title>
										<div class="d-flex flex-row align-center pointer" @click="model.type = typePrivate">
											<div class="mr-3">
												<v-radio :value="typePrivate" class="ma-3"/>
											</div>
											<div class="headline">
												{{ $t('constants.private') }}
											</div>
										</div>
									</template>
								</AsiCard>
							</AsiRadioGroup>
						</div>
						<v-divider/>
						<div class="pa-6">
							<AsiCurrencyAutocomplete v-model="model.currency" :rules="model.rules('currency')"/>
						</div>
						<v-divider/>
						<div class="pa-6">
							<AsiTextField v-model="model.externalId"
							              :label="$t('customer.externalId')"
							              :placeholder="$t('customer.externalId')"/>
						</div>
					</v-form>
					<v-divider/>
					<div class="px-6 py-3 grey lighten-5 d-flex flex-row justify-center align-center">
						<AsiStepperNavigation :next-disabled="!stepTypeComplete" color="secondary" small
						                      @next="step = stepUser" hide-prev/>
					</div>
				</v-stepper-content>

				<v-stepper-content :step="stepUser" class="pa-0 scrollable-content">
					<v-form v-model="userDataValid">
						<div class="ma-6">
							<v-row>
								<v-col>
									<AsiTextField v-model="model.username"
									              :label="$t('ui.terms.username')"
									              :placeholder="$t('ui.terms.username')"
									              :rules="model.rules('username')"
									              autocomplete="username"/>
								</v-col>
							</v-row>
						</div>
						<v-divider/>
						<div class="ma-6">
							<v-row>
								<SalutationInput v-model="model.salutation"/>
							</v-row>
							<v-row>
								<v-col :cols="sMobile ? 12 : 9/2">
									<AsiTextField v-model="model.firstname" :rules="model.rules('firstname')"
									              :label="$t('user.firstname')" :placeholder="$t('user.firstname')"/>
								</v-col>
								<v-col :cols="sMobile ? 12 : 9/2">
									<AsiTextField v-model="model.lastname" :rules="model.rules('lastname')"
									              :label="$t('user.lastname')" :placeholder="$t('user.lastname')"/>
								</v-col>
							</v-row>
						</div>
						<v-divider/>
						<div class="ma-6">
							<v-row>
								<v-col>
									<AsiTextField v-model="model.customerPhone" :rules="model.rules('customerPhone')"
									              :label="$t('user.phone')" :placeholder="$t('user.phone')"/>
								</v-col>
							</v-row>
						</div>
						<v-divider/>
						<div class="ma-6">
							<v-row>
								<v-col>
									<AsiLocaleAutocompleteInput v-model="model.locale" :rules="model.rules('locale')"
									                            :label="$t('user.locale')" :placeholder="$t('user.locale')"/>
								</v-col>
							</v-row>
						</div>
					</v-form>
					<v-divider/>
					<div class="px-6 py-3 grey lighten-5 d-flex flex-row justify-center align-center">
						<AsiStepperNavigation :next-disabled="!stepUserComplete" color="secondary" small
						                      @prev="step = stepType" @next="step = stepAddresses"/>
					</div>
				</v-stepper-content>

				<v-stepper-content :step="stepAddresses" class="pa-0 scrollable-content">
					<div v-if="model.addresses.length > 0" class="ma-6">
						<AddressForm v-for="(address, i) in model.addresses" :key="i" v-model="addressesValid[i]"
						             :model="address" :allow-delete="i !== 0" @requestDelete="deleteAddress(i)"
						             :allow-type-selection="model.type !== typeBusiness" :address-type="model.type === typeBusiness ? AddressType.addressBusiness : AddressType.addressPrivate"
						             @requestDefaultShippingAddress="setDefaultShippingAddress(i, $event)"
						             @requestDefaultBillingAddress="setDefaultBillingAddress(i, $event)"/>
					</div>
					<p v-else class="ma-6 text-center grey--text">
						{{ $t('address.terms.noAddresses') }}
					</p>
					<v-divider/>
					<div class="d-flex flex-row justify-center align-center pa-6">
						<AsiBtn :icon="icons.add" @click="addAddress" color="primary">
							{{ $t('address.terms.add') }}
						</AsiBtn>
					</div>
					<v-divider/>
					<div class="px-6 py-3 grey lighten-5 d-flex flex-row justify-center align-center">
						<AsiStepperNavigation :next-disabled="!stepAddressesComplete" color="secondary" small
						                      @prev="step = stepUser" @next="step = stepSummary"/>
					</div>
				</v-stepper-content>

				<v-stepper-content :step="stepSummary" class="pa-0 scrollable-content">
					<div class="pt-6">
						<AsiCardDetail class="mx-6" :title="$t('user.terms.account')" multi-column :columns="2">
							<AsiCardDetailEntry :icon="icons.customer" :label="$t('customer.type')" :value="customerTypeLabel"/>
							<AsiCardDetailEntry :icon="icons.currency" :label="$t('currency.singular')" :value="model.currency"/>
							<AsiCardDetailEntry v-if="model.type === typeBusiness" :icon="icons.phone" :label="$t('customer.phone')" :value="model.phone"/>
							<AsiCardDetailEntry :icon="icons.externalSource" :label="$t('customer.externalId')" :value="model.externalId"/>
						</AsiCardDetail>
						<AsiCardDetail class="mx-6" :title="$t('user.singular')" multi-column :columns="2" :no-bottom-margin="model.addresses.length === 0">
							<AsiCardDetailEntry :icon="icons.user" :label="$t('user.firstname')" :value="model.firstname"/>
							<AsiCardDetailEntry :icon="icons.user" :label="$t('user.lastname')" :value="model.lastname"/>
							<AsiCardDetailEntry :icon="icons.username" :label="$t('ui.terms.username')" :value="model.username"/>
							<AsiCardDetailEntry :icon="icons.phone" :label="$t('user.phone')" :value="model.customerPhone"/>
							<AsiCardDetailEntry :icon="icons.language" :label="$t('user.locale')" :value="$t(`locale.${model.locale}`)"/>
						</AsiCardDetail>
						<AsiCardDetail class="ma-6" v-if="model.addresses.length > 0" :title="$t('address.plural')" multi-column :columns="2"
						               no-bottom-margin>
							<AsiCardDetailEntry v-for="(address, i) in model.addresses" :key="i"
							                    :icon="icons.address" :label="addressLabel(address, i)">
								<div>
									<div v-for="(line, j) in addressLines(address)" :key="`line-${j}`">
										{{ line }}
									</div>
								</div>
								<div v-if="address.isDefaultShippingAddress || address.isDefaultBillingAddress" class="mt-1">
									<AsiChip v-if="address.isDefaultShippingAddress" label x-small class="mr-3">
										{{ $t('address.terms.shippingAddress') }}
									</AsiChip>
									<AsiChip v-if="address.isDefaultBillingAddress" label x-small>
										{{ $t('address.terms.billingAddress') }}
									</AsiChip>
								</div>
							</AsiCardDetailEntry>
						</AsiCardDetail>

						<v-expand-transition>
							<div v-show="createState !== createStateNone">
								<v-divider/>
								<div class="pa-6">
									<template v-if="createState === createStateFail">
										<AsiAlert  v-for="error in errors" :key="error" type="error" :icon="icons.error" no-bottom-margin>
											{{ `${$t('customer.terms.creationError')}: ${error}` }}
										</AsiAlert>
									</template>
									<AsiAlert v-if="createState === createStateSuccess" type="success" :icon="icons.yes" no-bottom-margin>
										{{ $t('customer.terms.creationSuccess') }}
									</AsiAlert>
								</div>
							</div>
						</v-expand-transition>

						<v-divider/>
						<div class="px-6 py-3 grey lighten-5 d-flex flex-row justify-center align-center">
							<AsiStepperNavigation @prev="step = stepAddresses" hide-next color="secondary" small>
								<template v-slot:append>
									<AsiBtn :icon="icons.yes" :disabled="loading || createState === createStateSuccess" :loading="loading" @click="performCreation"
									        prevent-icon-mode color="success">
										{{ $t('ui.create') }}
									</AsiBtn>
								</template>
							</AsiStepperNavigation>
						</div>
					</div>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
	</section>
</template>

<script lang="ts">
	import {Component, Watch} from 'vue-property-decorator';
	import AsiTextField from "@/components/common/AsiTextField";
	import AsiCard from "@/components/common/AsiCard.vue";
	import AsiCurrencyAutocomplete from "@/components/common/AsiCurrencyAutocomplete.vue";
	import AsiRadioGroup from "@/components/common/AsiRadioGroup";
	import AsiStepperNavigation from "@/components/common/AsiStepperNavigation.vue";
	import SalutationInput from "@/components/common/SalutationInput.vue";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import AsiLocaleAutocompleteInput from "@/components/common/AsiLocaleAutocompleteInput.vue";
	import AddressForm from "@/components/address/AddressForm.vue";
	import {AddressType, CustomerType} from "@/helpers/constants";
	import AddressCreate from "@/models/address/AddressCreate";
	import {AxiosError} from "axios";
	import icons from "@/plugins/icons";
	import {mixins} from "vue-class-component";
	import ResponsiveChecks from "@/mixins/ResponsiveChecks.vue";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import {TranslateResult} from "vue-i18n";
	import AddressHelper from "@/helpers/AddressHelper";
	import AsiChip from "@/components/common/AsiChip.vue";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import AsiAlert from "@/components/common/AsiAlert.vue";
	import CustomerCreate from "@/models/customer/CustomerCreate";

	@Component({
		computed: {
			AddressType() {
				return AddressType;
			},
			icons() {
				return icons;
			}
		},
		components: {
			AsiAlert,
			AsiCardDetail,
			AsiChip,
			AsiCardDetailEntry, AddressForm,
			AsiLocaleAutocompleteInput,
			AsiBtn, SalutationInput, AsiStepperNavigation, AsiRadioGroup, AsiCurrencyAutocomplete, AsiCard, AsiTextField}
	})
	export default class CustomerCreateWizard extends mixins(ResponsiveChecks) {

		private readonly stepType = 1;
		private readonly stepUser = 2;
		private readonly stepAddresses = 3;
		private readonly stepSummary = 4;
		private step: number = this.stepType;
		private readonly typeBusiness = CustomerType.business;
		private readonly typePrivate = CustomerType.private;
		private readonly createStateNone = 0;
		private readonly createStateStarted = 1;
		private readonly createStateSuccess = 2;
		private readonly createStateFail = 3;
		private createState: number = this.createStateNone;
		private createdId: string | null = null;

		private model: CustomerCreate = new CustomerCreate();
		private loading: boolean = false;
		private typeDataValid: boolean = false;
		private userDataValid: boolean = false;
		private addressesValid: boolean[] = [];
		private addressStepVisited: boolean = false;
		private summaryStepVisited: boolean = false;
		private errors: string[] = [];

		private get stepTypeComplete(): boolean {
			return this.typeDataValid;
		}

		private get stepUserComplete(): boolean {
			return this.userDataValid;
		}

		private get stepAddressesComplete(): boolean {
			return this.addressDataValid && this.addressStepVisited;
		}

		private get addressDataValid(): boolean {
			return !this.addressesValid.some(v => !v);
		}

		private addAddress(): void {
			this.createAddress();
		}

		private createAddress(): void {
			const address = new AddressCreate();
			if (this.model.addresses.length === 0) {
				address.isDefaultShippingAddress = true;
				address.isDefaultBillingAddress = true;
			}
			this.model.addresses.push(address);
			this.addressesValid.push(true);
		}

		public mounted(): void {
			this.createAddress();
		}

		@Watch('step')
		private onStepChanged(value: number): void {
			if (value === this.stepUser && this.model.type === this.typeBusiness && this.model.customerPhone === null) {
				this.model.customerPhone = this.model.phone;
			} else if (value === this.stepAddresses) {
				this.model.addresses[0].company = this.model.customerName;
				this.model.addresses[0].salutation = this.model.salutation;
				this.model.addresses[0].firstname = this.model.firstname;
				this.model.addresses[0].lastname = this.model.lastname;
				this.addressStepVisited = true;
			} else if (value === this.stepSummary) {
				this.summaryStepVisited = true;
			}
		}

		@Watch('model.type')
		private onModelTypeChanged(value: CustomerType): void {
			if (value === CustomerType.private) {
				this.model.customerName = null;
				this.model.phone = null;
				const form = this.$refs.creationForm as HTMLFormElement;
				form.resetValidation();
			}
		}

		private performCreation(): void {
			if (this.model.type === this.typePrivate) {
				this.model.phone = this.model.customerPhone;
			}

			this.createState = this.createStateStarted;
			this.loading = true;
			this.$customerServiceAdmin.create(this.model)
				.then(res => {
					this.createState = this.createStateSuccess;
					this.createdId = res.id;
				})
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

		protected handleErrors(err: AxiosError): void {
			const errorData: string | string[] = err.response?.data ?? null;
			if (errorData === null) this.errors = [];

			this.createState = this.createStateFail;
			this.errors = Array.isArray(errorData) ? errorData : [errorData];
		}

		private deleteAddress(index: number): void {
			if (index !== 0) {
				this.model.addresses = this.model.addresses.filter((a: AddressCreate, i: number) => i !== index);
				this.addressesValid = this.addressesValid.filter((a: boolean, i: number) => i !== index);
			}
		}

		private setDefaultShippingAddress(index: number, value: boolean): void {
			this.model.addresses.forEach((a: AddressCreate, i: number) => a.isDefaultShippingAddress = value && i === index);
		}

		private setDefaultBillingAddress(index: number, value: boolean): void {
			this.model.addresses.forEach((a: AddressCreate, i: number) => a.isDefaultBillingAddress = value && i === index);
		}

		private get customerTypeLabel(): string | TranslateResult | null {
			if (this.model.type === null) return null;
			return this.$t(`constants.${this.model.type === CustomerType.business ? 'business' : 'private'}`);
		}

		private addressLabel(address: AddressCreate, index: number): string {
			return address.label ?? `${this.$t('address.singular')} ${index + 1}`;
		}

		private addressLines(address: AddressCreate): string[] {
			return AddressHelper.addressLines(address);
		}
	}
</script>

<style scoped lang="scss">

	.scrollable-content {
		overflow: auto;
		max-height: 800px;
	}

</style>
